<template>
  <transition name="fade" mode="out-in">
    <div class="ot-modal" v-if="showModal" @click="clickOutside">
      <OTOutline class="ot-modal-content" @click.stop>
        <slot name="title"></slot>
        <slot name="content"></slot>
        <div class="ot-actions-container" v-if="backButton || $slots.actions">
          <OTBackButton v-if="backButton" @click="backButtonClicked" />
          <div
            class="ot-modal-actions"
            :class="{
              'with-back-button': backButton,
              'without-back-button': !backButton,
            }"
          >
            <slot name="actions"></slot>
          </div>
        </div>
      </OTOutline>
    </div>
  </transition>
</template>

<script setup>
import OTOutline from "./OTOutline.vue";
import OTBackButton from "./OTBackButton.vue";
import { watch } from "vue";
const props = defineProps({
  showModal: Boolean,
  contentPadding: {
    type: String,
    default: "40px",
  },
  mobilePadding: {
    type: String,
    default: "20px",
  },
  backButton: {
    type: Boolean,
    default: false,
  },
  useClickOutside: {
    type: Boolean,
    default: true,
  },
});

const clickOutside = () => {
  if (props.useClickOutside) {
    emit("closeModal");
  }
};

watch(
  () => props.showModal,
  (newVal) => {
    if (newVal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }
);

const emit = defineEmits(["backButtonClicked", "closeModal"]);

const backButtonClicked = () => {
  emit("backButtonClicked");
};
</script>

<style scoped lang="scss">
.ot-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  .ot-modal-content {
    overflow: auto;
    min-height: 600px;

    padding: v-bind(contentPadding);
    max-width: 600px;
    width: 100%;
    text-align: center;
    font-size: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .ot-actions-container {
      display: flex;
      align-items: center;
      width: 100%;
      margin-top: 20px;
      .ot-modal-actions {
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        gap: 1px;
        &.with-back-button {
          transform: translateX(-25px);
        }
        &.without-back-button {
          width: 100%;
        }
      }
    }
  }
  @media (max-width: 768px) {
    .ot-modal-content {
      max-width: 400px;
      min-height: unset;
      padding: v-bind(mobilePadding);
      font-size: 20px;
      .ot-actions-container {
        margin-top: 10px;
        .ot-modal-actions {
          &.with-back-button {
            transform: translateX(-20px);
          }
        }
      }
    }
  }
  @media (max-width: 768px) {
    padding: 10px;
  }
}
</style>
